import * as React from "react"

function SpeedNeedle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={30} height={124} viewBox="0 0 30 124" {...props}>
      <title>{"Needle"}</title>
      <g transform="translate(1)" fill="none" fillRule="evenodd">
        <circle
          stroke="#FFF"
          strokeWidth={2}
          fill="#FFF"
          cx={14}
          cy={101}
          r={6}
        />
        <circle stroke="#FFF" cx={14} cy={101} r={14} />
        <path fill="#FFF" d="M12 0h4v124h-4z" />
      </g>
    </svg>
  )
}

export default SpeedNeedle
